module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app__content section"
  }, [_c('div', {
    staticClass: "section__wrapper"
  }, [_c('div', {
    staticClass: "section__content"
  }, [_c('h2', {}, [_vm._v("User approval")]), _vm._v(" "), _c('table', {
    staticClass: "admin__table"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.users), function(user) {
    return _c('tr', {
      key: user.id,
      staticClass: "admin__table-row"
    }, [_c('td', {
      staticClass: "admin__table-cell"
    }, [_vm._v("\n            " + _vm._s(user.fullname) + "\n          ")]), _vm._v(" "), _c('td', {
      staticClass: "admin__table-cell"
    }, [_vm._v("\n            " + _vm._s(user.username) + "\n          ")]), _vm._v(" "), _c('td', {
      staticClass: "admin__table-cell"
    }, [_vm._v("\n            " + _vm._s(user.roles.indexOf('ROLE_ADMIN') > -1) + "\n          ")]), _vm._v(" "), _c('td', {
      staticClass: "admin__table-cell"
    }, [_c('ui-toggle', {
      attrs: {
        "toggle": user.approved
      },
      nativeOn: {
        "click": function($event) {
          _vm.toggleUserApproval(user.id, !user.approved)
        }
      }
    })], 1)])
  })], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "admin__table-row admin__table-row--heading"
  }, [_c('th', {
    staticClass: "admin__table-heading admin__table-cell"
  }, [_vm._v("\n            Full name\n          ")]), _vm._v(" "), _c('th', {
    staticClass: "admin__table-heading admin__table-cell"
  }, [_vm._v("\n            Username\n          ")]), _vm._v(" "), _c('th', {
    staticClass: "admin__table-heading admin__table-cell"
  }, [_vm._v("\n            Admin\n          ")]), _vm._v(" "), _c('th', {
    staticClass: "admin__table-heading admin__table-cell"
  }, [_vm._v("\n            Approved\n          ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5700280a","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/user-approval.vue
// module id = 228
// module chunks = 1